import { hot } from 'react-hot-loader/root';
import React from 'react';
import { MujiRouter, Router } from '@souche-f2e/muji';
const routes = [
    {
        "path": "/",
        "children": [
            {
                "path": "",
                "component": require('../pages/index.jsx').default
            },
            {
                "path": "Login",
                "children": [
                    {
                        "path": "",
                        "component": require('../pages/Login/index.jsx').default
                    }
                ]
            },
            {
                "path": "uppwd",
                "children": [
                    {
                        "path": "",
                        "component": require('../pages/uppwd/index.jsx').default
                    }
                ]
            }
        ],
        "component": require('../pages/_layout/index.jsx').default
    }
];
routes.push({
    "path": "*",
    "component": require('../pages/404').default,
});
const routerOptions = {
    mode: "hash",
    routes,
};
export const router = new Router(routerOptions);
const Root = () => (<MujiRouter router={router}/>);
export default hot(Root);
